import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DialogService } from 'primeng/dynamicdialog';

import { map, merge, Observable, Subject } from 'rxjs';

import { IStepLayoutData } from 'editing-tool/src/app/shared/components/paper/steps/step-layout-data';
import { NoteTypeEnum } from 'sc-common';
import { ICommentsData } from 'sc-common/shared/components/comments-dialog/comments-dialog-data';
import { CommentsDialogComponent } from 'sc-common/shared/components/comments-dialog/comments-dialog.component';

@Component({
    selector: 'et-step-layout',
    templateUrl: './step-layout.component.html',
    styleUrls: ['./step-layout.component.scss'],
    standalone: false
})
export class StepLayoutComponent implements OnInit, OnDestroy {

    @Input()
    public data: IStepLayoutData;

    public requestInProcess: boolean;

    public commentsCount$: Observable<number>;

    private readonly _destroy$ = new Subject<void>();

    private readonly _notesCountChanged$ = new Subject<number>();

    constructor(
        private readonly _route: ActivatedRoute,
        private readonly _router: Router,
        private readonly _dialogService: DialogService) {
    }

    public ngOnInit(): void {

        this.commentsCount$ = merge(this.data.comments.count$, this._notesCountChanged$);
    }

    public ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();

        this._notesCountChanged$.complete();
    }

    public navigateBack(): void {
        this._router.navigate(this.data.previousStepRoute, { relativeTo: this._route });
    }

    public navigateNext(): void {
        this._router.navigate(this.data.nextStepRoute, { relativeTo: this._route });
    }

    public openComments(): void {
        const dialogData: ICommentsData = {
            noteType: NoteTypeEnum.AuthorComment,
            notesCountChanged$: this._notesCountChanged$,
            addCommentAction: this.data.comments.addAction,
            comments$: this.data.comments.comments$
                .pipe(map(comments => comments.map(c => ({ comment: c, updateAction: this.data.comments.updateAction, deleteAction: this.data.comments.deleteAction }))))
        };

        this._dialogService.open(CommentsDialogComponent, {
            header: $localize`Comments between author and editor(s)`,
            width: '50vw',
            closable: true,
            data: dialogData
        });
    }
}
